"use client";

import { motion } from "motion/react";

import { TextReveal } from "@/components/elements/text-reveal";
import { FaqAccordion } from "@/components/sections/faq-accordion";
import { FAQ_ITEMS, type FaqItem } from "@/lib/faq-data";
import { cn } from "@/lib/utils";

export function Faq({
  containerClassName,
  items = FAQ_ITEMS,
  eyebrow = "Common questions",
}: {
  containerClassName?: string;
  items?: readonly FaqItem[];
  eyebrow?: string;
}) {
  return (
    <section id="faq" className="section-padding">
      <div className={cn("container", containerClassName)}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={{ hidden: {}, visible: {} }}
        >
          <TextReveal mode="animate" className="mb-10">
            <p className="text-text-tertiary text-[11px] font-semibold tracking-[1.4px] uppercase">
              {eyebrow}
            </p>
          </TextReveal>
          <FaqAccordion items={items} />
        </motion.div>
      </div>
    </section>
  );
}
